import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle, Timer } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Field } from "@/components/common";
import { Brand, Copyright } from "@/pages/Login";
import { PricingSection } from "@/components/Pricing";

const PERKS = ["14 gün tüm Pro özellikler açık", "Kredi kartı gerekmez", "Verileriniz yalnızca size ait, ayrı şirket alanı", "İstediğiniz an iptal; taahhüt yok"];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", company: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await register(f);
      toast.success("Hoş geldiniz! 14 günlük deneme süreniz başladı.");
      nav("/", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    }
    setBusy(false);
  };

  return (
    <div>
    <div className="grid min-h-screen lg:grid-cols-[1fr_1fr]">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-zinc-950 p-12 text-white grain lg:flex" data-testid="register-showcase">
        <div className="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-[#fdba74]/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 right-10 h-80 w-80 rounded-full bg-[#2dd4bf]/15 blur-3xl" />
        <Brand className="relative text-3xl" />
        <div className="relative max-w-lg">
          <div className="promo-float inline-flex items-center gap-2 rounded-full border border-[#fdba74]/40 bg-[#fdba74]/10 px-4 py-2 text-sm font-semibold text-[#fdba74]">
            <Timer weight="fill" /> İlk 14 gün bizden!
          </div>
          <h1 className="mt-6 font-display text-5xl font-bold leading-[1.05] tracking-tight">
            Hemen <span className="promo-gradient-text">ücretsiz</span> başlayın.
          </h1>
          <ul className="mt-8 space-y-3 text-zinc-300">
            {PERKS.map((p) => (
              <li key={p} className="flex items-center gap-3"><CheckCircle weight="fill" className="shrink-0 text-[#2dd4bf]" size={20} />{p}</li>
            ))}
          </ul>
        </div>
        <p className="relative text-xs text-zinc-500">Kayıt olduğunuz anda hazır bir ön muhasebe paneli sizi bekliyor.</p>
      </div>
      <div className="flex items-center justify-center bg-gradient-to-br from-white via-white to-[#fff7ed] p-6">
        <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-5" data-testid="register-form">
          <div>
            <Brand className="text-3xl lg:hidden" light={false} />
            <div className="mt-4 h-1 w-14 bg-[#2dd4bf]" />
            <h2 className="mt-3 font-display text-2xl font-bold">14 Gün Ücretsiz Dene</h2>
            <p className="mt-1 text-sm text-muted-foreground">Kredi kartı gerekmez, tüm Pro özellikleri açık.</p>
          </div>
          <Field label="Adınız Soyadınız">
            <Input required value={f.name} onChange={set("name")} data-testid="register-name-input" className="rounded-[4px]" />
          </Field>
          <Field label="Firma Adı">
            <Input required value={f.company} onChange={set("company")} data-testid="register-company-input" className="rounded-[4px]" />
          </Field>
          <Field label="E-posta">
            <Input type="email" required value={f.email} onChange={set("email")} data-testid="register-email-input" className="rounded-[4px]" />
          </Field>
          <Field label="Telefon (isteğe bağlı)">
            <Input value={f.phone} onChange={set("phone")} data-testid="register-phone-input" className="rounded-[4px]" placeholder="05xx xxx xx xx" />
          </Field>
          <Field label="Şifre (en az 8 karakter)">
            <Input type="password" required minLength={8} value={f.password} onChange={set("password")} data-testid="register-password-input" className="rounded-[4px]" />
          </Field>
          {err && <div className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="register-error">{err}</div>}
          <Button type="submit" disabled={busy} className="promo-shimmer h-11 w-full rounded-[4px] bg-[#fdba74] font-bold text-zinc-950 transition-colors hover:bg-[#fb923c]" data-testid="register-submit-button">
            {busy ? "Hesabınız hazırlanıyor…" : "Ücretsiz Denemeyi Başlat"}
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            Zaten hesabınız var mı? <Link to="/login" className="font-semibold text-teal-700 hover:underline" data-testid="register-login-link">Giriş yapın</Link>
          </p>
        </form>
      </div>
    </div>
    <div className="bg-white px-6 py-16 lg:px-12"><div className="mx-auto max-w-6xl"><PricingSection dark={false} /></div>
      <div className="mx-auto mt-12 flex max-w-6xl items-center justify-between border-t pt-6 text-xs text-slate-500"><Copyright light={false} /><span>Tüm hakları saklıdır</span></div>
    </div>
    </div>
  );
}
